@if (showPam()) {
  <bit-nav-group icon="bwi-lock-encrypted" [text]="'privilegedControls' | i18n" route="pam">
    <bit-nav-item [text]="'pamAccessRules' | i18n" route="pam/access-rules" />
  </bit-nav-group>
}
